



































































































































































































































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_variables from '@/mixins/axios/indicador_variables'
//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'
//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import indicador_frecuencias from '@/mixins/axios/indicador_frecuencias'

//@ts-ignore
import indicador_clasificaciones from '@/mixins/axios/indicador_clasificaciones'



//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
           
           
           
          
            {
                tag:'clave',
                data:'clave',
                active:true
            },
             {
                tag:'nombre',
                data:'nombre',
                active:true
            },
            
             {
                tag:'objetivo_indicador',
                data:'objetivo_indicador',
                active:true
            },
            {
                tag:'unidad_medida_resultado',
                data:'unidad_medida_resultado',
                active:true
            },
             /*{
                tag:'clasificacion',
                data:'clasificacion',
                active:true
            },
             {
                tag:'formula',
                data:'formula',
                active:true
            },
            
             {
                tag:'frecuencia',
                data:'frecuencia',
                active:true
            },*/
             {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
                tag:'departamento',
                data:'departamento',
                active:true
            },
             /*{
                tag:'valor_min',
                data:'valor_min',
                active:true
            },
             {
                tag:'valor_max',
                data:'valor_max',
                active:true
            },
             {
                tag:'meta',
                data:'meta',
                active:true
            },
             {
                tag:'motivo',
                data:'motivo',
                active:true
            },
             {
                tag:'aceptado',
                data:'aceptado',
                active:true
            },*/
             {
                tag:'imprimirIndicador',
                data:'imprimirIndicador',
                active:false
            },
              /*{
                tag:'tipo',
                data:'tipo',
                active:true
            },*/
           
            {
                tag:'edit',
                data:'edit',
                active:false
            },
              {
                tag:'delete',
                data:'delete',
                active:false
            },
           
        ],

        id:null as any,

      idclasificacion:0,
      clave:'' as any,
      nombre:'' as any,
      objetivo_indicador:'' as any,
      interpretacion:'' as any,
     // idvariables:'' as any,
      variables_agregadas:'' as any,
      formula:'' as any,
      unidad_medida_resultado:'' as any,
      variables_indicadores:[] as any,
      idfrecuencia:0,
      idsecretaria:0,
      iddepartamento:0,
      valor_min:'' as any,
      valor_max:'' as any,
      meta:'' as any,
    aceptado:0,
    motivo:'' as any,
    selectedvar:0,
    type:'',
    tipo:0,
 dimension: "" as any,
      nivel: "" as any,
      tendencia: "" as any,
      tipo_meta: "" as any,
      movimiento: "" as any,
      persona_responsable: "" as any,
      claridad: "" as any,
      relevancia: "" as any,
      economica: "" as any,
      monitoreable: "" as any,
      adecuado: "" as any,
      aportacion_marginal: "" as any,

      semaforo_verde: "" as any,
      semaforo_amarillo: "" as any,
      semaforo_rojo: "" as any,


var0:'',
var1:'',
var2:'',

var3:'',
var4:'',
var5:'',
var6:'',

    formulas:{
f1:'(´V1´/´V2´)*100',
f2:'´V1´/´V2´',
f3:'((´V1´-´V2´)/´V2´)*100',

f4:'(´V1´/´V2´)*100000',

    },
     
     
         
         indicador_variablesdata:[] as any,
              indicador_administradordata:[] as any,
               departamentos:[] as any,
     dependencias:[] as any,
     indicador_frecuencias:[] as any,
     indicador_clasificaciones:[] as any,
      
    }
  },
     mixins: [indicador_administradores, dependencias,
     departamentos,
     indicador_frecuencias,
     indicador_variables,
     indicador_clasificaciones],
     validations: {
    
           idclasificacion: {
      required,
    },
    
           clave: {
      required,
    },
    
           nombre: {
      required,
    },
    
           objetivo_indicador: {
      required,
    },
    
           interpretacion: {
      required,
    },
    
          
    
       
           unidad_medida_resultado: {
      required,
    },
    
           idfrecuencia: {
      required,
    },
    
           idsecretaria: {
      required,
    },
       iddepartamento: {
      required,
    },
          valor_min: {
      required,
    },
          valor_max: {
      required,
    },
          meta: {
      required,
    },
       motivo: {
      required,
    },
       aceptado: {
      required,
    },
    
     type: {
      required,
    },
    
 tipo: {
      required,
    },
    dimension: {
      required,
    },
   nivel: {
      required,
    },

    tendencia: {
      required,
    },

    tipo_meta: {
      required,
    },

    movimiento: {
      required,
    },

    persona_responsable: {
      required,
    },

    claridad: {
      required,
    },

    relevancia: {
      required,
    },

    economica: {
      required,
    },

    monitoreable: {
      required,
    },

    adecuado: {
      required,
    },

    aportacion_marginal: {
      required,
    },
    semaforo_verde: {
      required,
    },
    semaforo_amarillo: {
      required,
    },
    semaforo_rojo: {
      required,
    },
  },
  methods:{
      imprimirindica(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETINDICADOR',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/indicadores/imprimirindicador1')
//this.getDataDepartamentos();

     },
      formatVarsSet(){
if(this.type=='f1'||this.type=='f2'||this.type=='f4'){
           this.var0=this.formula.split('´')[0];
           this.var1=this.formula.split('´')[1];
            this.var2=this.formula.split('´')[2];
            this.var3=this.formula.split('´')[3];
            this.var4=this.formula.split('´')[4];
       }else{
           this.var0=this.formula.split('´')[0];
           this.var1=this.formula.split('´')[1];
            this.var2=this.formula.split('´')[2];
            this.var3=this.formula.split('´')[3];
            this.var4=this.formula.split('´')[4];
             this.var5=this.formula.split('´')[5];
            this.var6=this.formula.split('´')[6];
       }
      },
      AsingarVariable(){
          if(this.selectedvar!=0){
let data=this.indicador_variablesdata.filter(item => item.id ==this.selectedvar)[0];
let variable={
indicador_variables_id:data.id
};
 this.variables_indicadores.push(variable);
          }

         
      },
searchVar(id){
  
    if(this.variables_indicadores.filter(item => item.indicador_variables_id ==id).length>0){
        return true;

    }else{
        return false;
    }
    
},
eliminarVariable(id){
   this.variables_indicadores=this.variables_indicadores.filter(item => item.indicador_variables_id !==id);
    
},
async getVariables() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_variablesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
  onChangeT(event){

      },

      onChangeAceptar(event){

      },
      SelectForm(event){
this.formula=this.formulas[event.target.value];

 this.formatVarsSet();
      },
       onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
   onChangeC(event){
//console.log(event.target.value)
this.getDataClasificacion(event.target.value);

},
      onChangeF(event){
//console.log(event.target.value)

this.getDataFrecuencia(event.target.value);
},
       async getDataClasificacion(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_CLASIFICACION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_clasificaciones=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

       async getDataFrecuencia(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_frecuencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_ADMINISTRADORES(row).then(response => {

                    if (response != null) {

 this.indicador_administradordata=this.indicador_administradordata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){

this.id=null;
 this.semaforo_verde=null;this.semaforo_amarillo=null;this.semaforo_rojo=null;
           
                 this.idclasificacion=0;
                 this.clave=null;
                 this.nombre=null;
                 this.objetivo_indicador=null;
                 this.interpretacion=null;
                 //this.idvariables=0;
                 this.variables_agregadas=null;
                 this.formula=null;
                 this.unidad_medida_resultado=null;
                 this.idfrecuencia=0;
                 this.idsecretaria=0;
                 this.iddepartamento=0;
                 this.valor_min=null;
                 this.valor_max=null;
                 this.meta=null;
                 this.motivo=null;
                 this.aceptado=0;
                 this.variables_indicadores=[];
                 this.type=null;
                 this.tipo=0;
     this.dimension = null;
      this.nivel = null;
      this.tendencia = null;
      this.tipo_meta = null;
      this.movimiento = null;
      this.persona_responsable = null;
      this.claridad = null;
      this.relevancia = null;
      this.economica = null;
      this.monitoreable = null;
      this.adecuado = null;
      this.aportacion_marginal = null;
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_administrador').modal('show')
      },
seteditar(row){


 this.id=row.id;
  this.semaforo_verde=row.semaforo_verde; 
  this.semaforo_amarillo=row.semaforo_amarillo; 
  this.semaforo_rojo=row.semaforo_rojo;
 this.idclasificacion=row.idclasificacion;
 this.clave=row.clave;
  this.nombre=row.nombre;
   this.objetivo_indicador=row.objetivo_indicador;
    this.interpretacion=row.interpretacion;
    // this.idvariables=row.idvariables;
      this.variables_agregadas=row.variables_agregadas;
       this.formula=row.formula;
       this.type=row.type;
       this.formatVarsSet();
        this.unidad_medida_resultado=row.unidad_medida_resultado;
         this.idfrecuencia=row.idfrecuencia;
          this.idsecretaria=row.idsecretaria;
           this.iddepartamento=row.iddepartamento;
  this.valor_min=row.valor_min;
    this.valor_max=row.valor_max;
      this.meta=row.meta;
         this.aceptado=row.aceptado;
    this.motivo=row.motivo;
        this.tipo=row.tipo;
        this.dimension = row.dimension;
      this.nivel = row.nivel;
      this.tendencia = row.tendencia;
      this.tipo_meta = row.tipo_meta;
      this.movimiento = row.movimiento;
      this.persona_responsable = row.persona_responsable;
      this.claridad = row.claridad;
      this.relevancia = row.relevancia;
      this.economica = row.economica;
      this.monitoreable = row.monitoreable;
      this.adecuado = row.adecuado;
      this.aportacion_marginal = row.aportacion_marginal;
    this.variables_indicadores=row.variables_indicadores;
console.log(this.variables_indicadores);
            
          
 $('#ac_modal_indicador_administrador').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_ADMINISTRADORES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_administradordata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Administradores, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
  $("#ac_modal_indicador_administrador").modal("hide");
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_ADMINISTRADORES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de desempeño enlaces modificado exitosamente, refresque la pagina");
  this.indicador_administradordata=this.indicador_administradordata.filter(item => item.id !== dat.id);
 this.indicador_administradordata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Administradores, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
  $("#ac_modal_indicador_administrador").modal("hide");
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)


let formula='';
if(this.type=='f1'||this.type=='f2'||this.type=='f4'){
if(this.var1==0||this.var1=='V1'){
    this.$root.$emit("alerta_show", "Favor de asignar valor a variable 1 formula");
    return;
}
if(this.var3==0||this.var3=='V2'){
    this.$root.$emit("alerta_show", "Favor de asignar valor a variable 2 formula");
    return;
}

formula=this.var0+'´'+this.var1+'´'+this.var2+'´'+this.var3+'´'+this.var4;
}else{
    if(this.var1==0||this.var1=='V1'){
    this.$root.$emit("alerta_show", "Favor de asignar valor a variable 1 formula");
    return;
}
if(this.var3==0||this.var3=='V2'){
    this.$root.$emit("alerta_show", "Favor de asignar valor a variable 2 formula");
    return;
}
if(this.var5==0||this.var5=='V2'){
    this.$root.$emit("alerta_show", "Favor de asignar valor a variable 3 formula");
    return;
}
formula=this.var0+'´'+this.var1+'´'+this.var2+'´'+this.var3+'´'+this.var4+'´'+this.var5+'´'+this.var6;
}
let dat={
  id:this.id,
     semaforo_verde:this.semaforo_verde,
  semaforo_amarillo:this.semaforo_amarillo, 
  semaforo_rojo:this.semaforo_rojo,


     idclasificacion:this.idclasificacion,
            clave:this.clave,
             nombre:this.nombre,
              objetivo_indicador:this.objetivo_indicador,
               interpretacion:this.interpretacion,
               // idvariables:this.idvariables,
                 variables_agregadas:this.variables_indicadores,
                  formula:formula,
                   unidad_medida_resultado:this.unidad_medida_resultado,
                    idfrecuencia:this.idfrecuencia,
                     idsecretaria:this.idsecretaria,
                      iddepartamento:this.iddepartamento,
                       valor_min:this.valor_min,
                        valor_max:this.valor_max,
                         meta:this.meta,
                             aceptado:this.aceptado,
                            motivo:this.motivo,
                        type:this.type,
                          tipo:this.tipo,
                          dimension: this.dimension,
        nivel: this.nivel,
        tendencia: this.tendencia,
        tipo_meta: this.tipo_meta,
        movimiento: this.movimiento,
        persona_responsable: this.persona_responsable,
        claridad: this.claridad,
        relevancia: this.relevancia,
        economica: this.economica,
        monitoreable: this.monitoreable,
        adecuado: this.adecuado,
        aportacion_marginal: this.aportacion_marginal,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_ADMINISTRADORES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_administradordata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      this.getDataSecretarias();
      this.getDataFrecuencia();
    this.getDataClasificacion();
    this.getVariables();

      //alert('10')
  }
})
export default class Home extends Vue {}

